exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert[data-v-2869d932]{margin-bottom:var(--spacer-base)}\n", ""]);

// exports
